import React, { Fragment } from "react";
import { Link, NavLink } from "react-router-dom";

const Header = ({ name }) => {
  return (
    <Fragment>
      <section className="header header--2">
        <div className="top_bar top--bar2 d-flex align-items-center bg-primary">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="d-flex topbar_content justify-content-between">
                  <div className="top_bar--info order-0 d-none d-lg-block align-self-center">
                    <ul>
                      <li>
                        <span className="la la-envelope"></span>
                        <p>sales@vbtpl.com</p>
                      </li>
                      <li>
                        <span className="la la-envelope"></span>
                        <p>info@vbtpl.com</p>
                      </li>
                      <li>
                        <span className="la la-headphones"></span>
                        <p>+91 8912731634</p>
                      </li>
                      <li>
                        <span className="la la-headphones"></span>
                        <p>+91 9652622345</p>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="menu_area menu1">
          <div className="container">
            <nav className="navbar navbar-expand-lg navbar-light bg-light px-0">
              <Link className="navbar-brand order-sm-1 order-1" to="/">
                <img src="img/used/logo.png" alt="" />
              </Link>
              {window.innerWidth < 500 && name !== "Home" ? (
                <Link to="/" className="btn btn-secondary m-2">
                  Back To Home
                </Link>
              ) : null}
              <button
                className="navbar-toggler"
                type="button"
                data-toggle="collapse"
                data-target="#navbarSupportedContent2"
                aria-controls="navbarSupportedContent2"
                aria-expanded="false"
                aria-label="Toggle navigation"
              >
                <span className="la la-bars"></span>
              </button>

              <div
                className="collapse navbar-collapse order-md-1"
                id="navbarSupportedContent2"
              >
                <ul className="navbar-nav m-auto">
                  <li
                    className={name === "Home" ? "nav-item active" : "nav-item"}
                  >
                    <Link className="nav-link" to="/">
                      Home
                    </Link>
                  </li>
                  <li className="nav-item has_mega-lg">
                    <a className="nav-link" href="/#about">
                      About
                    </a>
                  </li>
                  <li className="nav-item">
                    <NavLink className="nav-link" to="/products">
                      Product
                    </NavLink>
                  </li>
                  <li className="nav-item">
                    <Link className="nav-link" to="/brochure">
                      Brochure
                    </Link>
                  </li>
                  <li className="nav-item">
                    <NavLink className="nav-link" to="/contact">
                      Contact
                    </NavLink>
                  </li>
                </ul>
              </div>

              <div className="nav_right_content d-flex align-items-center order-2 order-sm-2"></div>
            </nav>
          </div>
        </div>
      </section>
    </Fragment>
  );
};

export default Header;
